var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          d:
            "M13.600038,9.59978714 L2.40072219,9.59978714 C1.95828384,9.59978714 1.60022806,9.24173363 1.60022806,8.80005828 L1.60022806,6.46244778 L14.4005321,6.46244778 L14.4005321,8.80005828 C14.4005321,9.24173363 14.0417162,9.59978714 13.600038,9.59978714 M2.40072219,1.60021792 L13.600038,1.60021792 C14.0417162,1.60021792 14.4005321,1.95827144 14.4005321,2.39994679 L14.4005321,4.98386162 L1.60022806,4.98386162 L1.60022806,2.39994679 C1.60022806,1.95827144 1.95828384,1.60021792 2.40072219,1.60021792 M2.40072219,0 C1.07416734,0 0,1.07416053 0,2.39994679 L0,8.80005828 C0,10.1250843 1.07416734,11.2000051 2.40072219,11.2000051 L7.19988597,11.2000051 L7.19988597,13.3997821 L4.00019005,13.3997821 C3.5585119,13.3997821 3.19969592,13.7585958 3.19969592,14.2002711 C3.19969592,14.6419465 3.5585119,15 4.00019005,15 L12.0005702,15 C12.4422483,15 12.8003041,14.6419465 12.8003041,14.2002711 C12.8003041,13.7585958 12.4422483,13.3997821 12.0005702,13.3997821 L8.80011403,13.3997821 L8.80011403,11.2000051 L13.600038,11.2000051 C14.9258327,11.2000051 16,10.1250843 16,8.80005828 L16,2.39994679 C16,1.07416053 14.9258327,0 13.600038,0 L2.40072219,0 Z",
          id: "display_both"
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "g",
      {
        attrs: {
          id: "Page-1",
          stroke: "none",
          "stroke-width": "1",
          fill: "none",
          "fill-rule": "evenodd"
        }
      },
      [
        _c(
          "g",
          {
            attrs: {
              id: "Desktop-HD1",
              transform: "translate(-298.000000, -270.000000)"
            }
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Group",
                  transform: "translate(298.000000, 270.000000)"
                }
              },
              [
                _c("rect", {
                  staticStyle: { "mix-blend-mode": "color-burn" },
                  attrs: {
                    id: "Rectangle",
                    "fill-opacity": "0.01",
                    fill: "#E3E3E3",
                    x: "0",
                    y: "0",
                    width: "24",
                    height: "24"
                  }
                }),
                _vm._v(" "),
                _c(
                  "g",
                  {
                    attrs: {
                      id: "colors/branding/secondary",
                      transform: "translate(4.000000, 5.000000)"
                    }
                  },
                  [
                    _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                      _c("use", { attrs: { "xlink:href": "#display_both" } })
                    ]),
                    _vm._v(" "),
                    _c("use", {
                      attrs: {
                        id: "Mask",
                        fill: _vm.currentColor,
                        opacity: _vm.opacity,
                        "xlink:href": "#display_both"
                      }
                    })
                  ]
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }